import { getItemFromLocalStorage } from './getItemFromLocalStorage'

export const isProd =
  window.location.hostname === 'www.panenkafc.gg' ||
  window.location.hostname === 'panenkafc.gg' ||
  getItemFromLocalStorage('isProd')
